import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Button, LinkList } from '../../../components'
import { useMessage, useModalDialog } from '../../../hooks'
import { companyService } from '../../../services'
import { useNetworkDialog } from '../hooks/useNetworkDialog'
import { appName } from '../appConfig'

const CONTACT_FIELDS = [
  ['Bransch', 'company_industry'],
  ['Webb', 'company_website'],
]

const CompanyDetail = () => {
  const navigate = useNavigate()
  const { uuid } = useParams()
  const { showMessage } = useMessage()
  const { hideModalDialog } = useModalDialog()
  const { showCompanyDialog, showDeleteCompanyDialog } = useNetworkDialog()

  const [company, setCompany] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchCompany = () => {
    setLoading(true)
    companyService.getByUuid(uuid)
      .then(res => { setCompany(res.company); setLoading(false) })
      .catch(() => { showMessage('Kunde inte ladda företag', 'error'); setLoading(false) })
  }

  useEffect(() => { fetchCompany() }, [uuid]) // eslint-disable-line react-hooks/exhaustive-deps

  const deleteCompany = () => {
    showDeleteCompanyDialog(company, async () => {
      await companyService.destroy(uuid)
        .then(() => { hideModalDialog(); showMessage('Borttaget'); navigate(`/${appName}/companies`) })
        .catch(err => showMessage(err.message || 'Kunde inte ta bort', 'error'))
    })
  }

  if (loading || !company) return <div className="network-page"><p className="empty-text">Laddar…</p></div>

  const isClient = (company.caseCount || 0) > 0

  return (
    <div className="network-page network-detail-page">

      <div className="network-detail-header">
        <h2>
          {company.company_name}
          {isClient && <span className="pill pill-green pill-dashed network-header-pill">Kund</span>}
        </h2>
        <div className="network-detail-header-actions">
          <Button value="Redigera" className="button" onClick={() => showCompanyDialog(company, () => fetchCompany())} />
          <Button value="Ta bort" className="button network-danger-button" onClick={deleteCompany} />
        </div>
      </div>

      <div className="network-detail-layout">
        <div className="network-detail-left network-detail-card">

          {CONTACT_FIELDS.map(([label, field]) => (
            <div className="network-contact-row" key={field}>
              <span className="network-contact-label">{label}</span>
              <span className="network-contact-value">{company[field] || '—'}</span>
            </div>
          ))}

          <div className="network-detail-section">
            <LinkList
              title="Länkar"
              titleClassName="network-sec-title"
              links={company.links || []}
              onAdd={(link) => companyService.addLink(uuid, link).then(res => { fetchCompany(); return res.link })}
              onRemove={(link) => companyService.removeLink(uuid, link.company_link_id).then(fetchCompany)}
              sourceLabels={{ clients: 'Kunder' }}
            />
          </div>

          <div className="network-detail-section">
            <h3 className="network-sec-title">Anteckningar</h3>
            <p className="network-notes-text">{company.company_notes || '—'}</p>
          </div>

        </div>

        <div className="network-detail-right">
          <div className="network-detail-section">
            <h3 className="network-sec-title">Personer på företaget</h3>
            {(company.persons || []).length === 0
              ? <p className="empty-text">Inga personer</p>
              : (
                <table className="network-persons-table">
                  <thead>
                    <tr><th></th><th>Namn</th><th>Titel</th><th>E-post</th></tr>
                  </thead>
                  <tbody>
                    {company.persons.map(p => (
                      <tr key={p.person_uuid}>
                        <td><Link className="network-table-visa-btn" to={`/${appName}/persons/${p.person_uuid}`}>Visa</Link></td>
                        <td className="bold">{p.person_name}</td>
                        <td>{p.person_title || '—'}</td>
                        <td>{p.person_email || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )
            }
          </div>

          {(company.clientCases || []).length > 0 &&
            <div className="network-detail-section">
              <h3 className="network-sec-title">Kundcase</h3>
              {company.clientCases.map(c => (
                <div className="network-inv-row" key={c.client_case_id}>
                  <div className="network-inv-row-top">
                    <span className="network-inv-title">{c.client_case_slug}</span>
                  </div>
                  <Link className="network-inv-link" to={`/clients/${c.client_slug}`}>Visa i Kunder →</Link>
                </div>
              ))}
            </div>
          }
        </div>
      </div>

    </div>
  )
}

export default CompanyDetail
